export enum KpiQueries {
  ZoneOne = 'zoneOne',
  ZoneTwo = 'zoneTwo',
  ZoneThree = 'zoneThree',
  ZoneFour = 'zoneFour',
}
